/**
 * 功能: 表说表说的数据新增、修改数据
 */

<template lang="pug">
  div
    el-dialog(
      :title.sync="tableTitle"
      :visible.sync="tinymceVisible"
      width="70%"
      top="10vh"
      :before-close="cancel"
      :close-on-click-modal="false"
      :append-to-body="isChildDialog"
      @close="close")
      el-form(:model="newTable" :rules="rules" ref="tableRef" label-position="right" label-width="100px" :size="GLOBAL.SIZE_OF_INPUTBOX")
        el-row
          el-col(:span="8")
            el-form-item(label="标题" prop="title")
              el-input(v-model="newTable.title")
          el-col(:span="7")
            el-form-item(label="来源" prop="source")
              el-input(v-model="newTable.source")
          el-col(:span="7")
            el-form-item(label="厂牌", prop="brandName")
              brandSelect(v-model="newTable.brand" :brandName="newTable.brandName" @brandName="getbrandName")
              //- el-select(placeholder="请选择" v-model="newTable.source" clearable allow-create :filterable="true")
              //-   el-option(v-for="item in source" :key="item.value" :label="item.label" :value="item.label")
        el-row
          //- el-col(:span="8")
          //-   el-form-item(label="行业", prop="industry")
          //-     FrostIndustry(
          //-             v-model="newTable.industryId" v-bind:name="newTable.industry" v-on:change="newTable.industry = $event")
          el-col(:span="8")
            el-form-item(label="状态" prop="status")
              el-select(v-model="newTable.status"  placeholder="状态")
                el-option(v-for="item in STATUS" :label="item.label" :value="item.value" :key="item.value")
          el-col(:span="2" style="height: 100%")
            el-form-item
              el-checkbox(v-model="newTable.isPolicy") 政策
        el-row(type="flex")
          el-col(:span="16")
            el-form-item(label="描述")
              el-input( type="textarea" :rows="3" placeholder="请输入描述" v-model="newTable.description")
        tinymce(@addTable="addTable" :tinymceHtml="content" v-if="tinymceVisible" :status="newTable.status")
</template>
<script>
import brandSelect from '@/components/brandSelect'
import FrostIndustry from '../../../components/industry'
import tinymce from '../../../components/tinymce'
import Enum from '@/apis/enum'
export default {
  components: { tinymce, FrostIndustry, brandSelect },
  props: {
    newTable: Object,
    tableTitle: {
      type: String,
      default: '新建表格'
    },
    /* isChildDialog: 是否是嵌套的dialog */
    isChildDialog: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      tinymceVisible: false,
      content: {
        html: '',
        pureText: ''
      },
      rules: {
        title: { required: true, message: '请输入标题', trigger: 'blur' },
        source: { required: true, message: '请输入来源', trigger: 'blur' },
        industry: { required: true, message: '请选择行业', trigger: 'blur' }
      },
      source: Enum.SOURCE
    }
  },
  created () {
    this.STATUS = Enum.STATUS
  },
  methods: {
    // 获取厂牌name
    getbrandName (brandName) {
      this.newTable.brandName = brandName
    },

    // 将数据填充到弹框里
    show () {
      this.content.html = this.newTable.html
      this.tinymceVisible = true
    },

    // 新增表格数据
    addTable (content) {
      if (!content.html) {
        this.$message({ type: 'error', message: '表说内容不能为空！' })
        return false
      }
      if (content.html && content.html.indexOf('</table>') < 0) {
        this.$message({ type: 'error', message: '请输入表格内容！' })
        return false
      }
      if (content.html.indexOf('<img') !== -1 && content.html.indexOf('data:') !== -1 && content.html.indexOf('base64') !== 0) {
        this.$message({ type: 'error', message: '输入数据不合法, 自动清空！' })
        this.content.html = ''
        this.content.pureText = ''
        return false
      }
      this.newTable.html = content.html || this.content.html
      this.newTable.pureText = content.pureText
      this.$refs.tableRef.validate(valid => {
        if (valid) {
          this.$emit('addTable', this.newTable, () => {
          })
          this.tinymceVisible = false
        }
      })
    },

    // 关闭弹框
    cancel () {
      this.tinymceVisible = false
      this.htmlVisible = false
      this.$nextTick(() => {
        this.$refs.tableRef.clearValidate()
      })
      this.$emit('cancel')
    },

    // 关闭dialog
    close () {
      this.$emit('close')
    }
  }

}
</script>
